import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { LoggerService } from '../shared/sdk/services/custom/logger.service';
import { Organization } from '../shared/sdk/models';
import { OrganizationService } from './organization.service';
import { StorageService } from '../shared/services/storage.service';

@Injectable()
export class ActiveOrgResolver implements Resolve<Organization> {
  constructor(
    private log: LoggerService,
    private orgService: OrganizationService,
    private router: Router,
    private storageService: StorageService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Organization> {
    return new Observable((obs) => {
      this.log.log('ActiveOrgResolver: resolve');

      const id = route.paramMap.get('id');

      this.orgService.active
        .pipe(
          take(1),
          switchMap((org: Organization) => {
            if (!org || org.id !== id) {
              this.log.log('ActiveOrgResolver: no org or not same id');
              return this.orgService.setActiveById(id);
            } else {
              this.log.log('ActiveOrgResolver: current active', org);
              return of(org);
            }
          }),
          take(1),
        )
        .subscribe(
          (org: Organization) => {
            if (org) {
              this.storageService.setItem(
                'Apollo::selectedOrganization',
                org.id,
              );

              obs.next(org);
              obs.complete();
            } else {
              // Not found by id or no organizaations
              this.log.log('ActiveOrgResolver: not found');
              this.storageService.removeItem('Apollo::selectedOrganization');

              // Keep query params if any
              const params = { ...route.queryParams };

              this.router.navigate(['/organizations/choose'], {
                queryParams: params,
              });

              obs.complete();
              return EMPTY;
            }
          },
          (err) => {
            this.log.error('ActiveOrgResolver: error');
            this.log.error(err);
            this.router.navigate(['/logout']);
            obs.complete();
            return EMPTY;
          },
        );
    });
  }
}
